export interface INewbuildingProductOptions {
  id: string;
  name: string;
  nv: boolean;
  builderId: string;
  isDealRequestSubstitutionPhone: boolean;
  parentId: number | null;
  cplExtra?: ICplExtra;
}

export interface ICplExtra {
  cplCalltracking?: number;
  cplDynamicCalltracking?: number;
}

export function getNewbuildingProduct({
  parentId,
  id,
  name,
  nv,
  builderId,
  isDealRequestSubstitutionPhone,
  cplExtra,
}: INewbuildingProductOptions) {
  return {
    brand: `${builderId}/developer`,
    dealType: 'other',
    id: Number(id),
    name,
    objectType: 'JK',
    position: 1,
    nv,
    consultant: isDealRequestSubstitutionPhone,
    extra: {
      ...cplExtra,
      parentId,
    },
  };
}
